import React from "react";

interface SurveyPreviewProps {
  moveNext: (
    questionId: number,
    value: string,
    rating: number,
    isLast: boolean
  ) => void;
  moveBack?: () => void;
  questions: Question[];
  previewQuestionIdx: number;
}
export const SurveyPreview = ({
  moveBack,
  moveNext,
  previewQuestionIdx,
  questions,
}: SurveyPreviewProps) => {
  const progress = (previewQuestionIdx * 100) / questions.length;
  return (
    <div className="h-full w-full">
      <div className="no-scrollbar flex flex-col justify-between">
        <div className="my-auto">
          {questions.map((question, idx) => (
            <QuestionForm
              key={question.key}
              question={question}
              onNext={(q: number, v: string, r: number) =>
                moveNext(q, v, r, idx === questions.length - 1)
              }
              onBack={moveBack}
              isVisible={idx === previewQuestionIdx}
            />
          ))}
          <ThankYou isVisible={previewQuestionIdx == questions.length} />
        </div>
        <div className="mt-8">
          <div className="flex justify-between mb-1">
            <span className="text-base font-medium text-primary-700 dark:text-white">
              Postęp
            </span>
            <span className="text-sm font-medium text-primary-700 dark:text-white">
              {Math.round(progress)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div
              className="bg-primary-600 h-2.5 rounded-full transition-widt duration-500"
              style={{ width: progress + "%" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

import { CiCircleCheck } from "react-icons/ci";
import { Question } from "./types";
import { QuestionForm } from "./QuestionForm";

interface ThankYouProps {
  isVisible: boolean;
}
const ThankYou = ({ isVisible }: ThankYouProps) => {
  return (
    <div className={`flex flex-col items-center ${isVisible ? "" : "hidden"}`}>
      <CiCircleCheck size={72} className="text-primary-500" />
      <span className="font-xl">Dziękujemy za wypełnienie ankiety.</span>
    </div>
  );
};
